import React, { useState, useRef } from "react";
import { useDropzone } from "react-dropzone";
import styles from "./styles.module.scss";
import upload from "app/utils/uploader";
import { cls } from "app/utils";
import EditPenIcon from "../../../public/images/edit-pen.svg";
import { Loading } from "../Wrappers";
import TeamAvatar from "../TeamAvatar";
import { useTranslation } from "react-i18next";

interface Props {
  avatar?: string;
  onUpload?: (avatar: any) => void;
  canEdit?: boolean;
}

const TeamAvatarWithEdit = ({ avatar, onUpload, canEdit = true }: Props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const uploadRef = useRef(null);

  const onDrop = async (acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];

      try {
        setIsLoading(true);
        const abortableUpload = upload(file, file.name, file.type, undefined);
        uploadRef.current = abortableUpload;
        const response = await abortableUpload.promise;
        if (uploadError) {
          setUploadError(false);
        }
        return onUpload(response);
      } catch (error) {
        console.error("Error during file upload:", error);
        setUploadError(true);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    // noClick: true,
    accept: {
      "image/*": [],
    },
  });
  return (
    <div className={cls(styles.container)}>
      <div className={styles.dropzone_inner}>
        {canEdit && !isLoading && (
          <div {...getRootProps({ className: "dropzone" })}>
            <span
              className={cls(styles.edit_pen_wrapper, {
                [styles.dropzone_inner_active]: isDragActive,
              })}
            >
              {<img className={styles.edit_pen} src={EditPenIcon} />}
              <input {...getInputProps()} id="media__uploader" />
            </span>
          </div>
        )}
        {isLoading && (
          <Loading
            isLoading={isLoading}
            loadType="spinner"
            className={styles.loader}
          />
        )}

        {!isLoading && (
          <TeamAvatar
            srcName={avatar}
            sizeWidth={100}
            sizeHeight={100}
            className={cls(styles.avatar, {
              [styles.dropzone_inner_active]: isDragActive,
            })}
          />
        )}
      </div>
      {uploadError && (
        <div className="helper-text error">{t("Something went wrong.")}</div>
      )}
    </div>
  );
};

export default TeamAvatarWithEdit;
